import React, { useState, useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { V2Card } from '@uhg-abyss/web/ui/Card';
import { V2Tabs } from '@uhg-abyss/web/ui/Tabs';
import { V2FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useFormV2 } from '@uhg-abyss/web/hooks/useForm';
import { TextSignatureTab } from './SignatureTabs/TextSignatureTab';
import { DrawSignatureTab } from './SignatureTabs/DrawSignatureTab';

const ElectronicSignatureHeading = styled('p', {
  fontSize: '30px',
  fontWeight: 700,
  color: '$primary1',
});

export const ElectronicSignature = () => {
  const form = useFormV2();
  const [activeTab, setActiveTab] = useState(0);
  const [hasVisitedDraw, setHasVisitedDraw] = useState(false);

  useEffect(() => {
    form.setValue('attestation.signatureTab', 'Text');
  }, []);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    if (tabIndex === 1) setHasVisitedDraw(true);
    form.setValue('attestation.signatureTab', tabIndex === 0 ? 'Text' : 'Draw');
  };

  return (
    <V2Card>
      <ElectronicSignatureHeading>
        Electronic signature
      </ElectronicSignatureHeading>

      <V2FormProvider state={form}>
        {/*
          V2Tabs is used ONLY for the tab button bar UI.
          Content is rendered below — always mounted, never unmounted by V2Tabs.
          CSS display toggle preserves canvas strokes, form state, and all messages.
        */}
        <V2Tabs
          title="Electronic signature"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          css={{
            'abyss-tabs-extended-border': { display: 'none' },
            'abyss-tabs-root': { marginBottom: '16px' },
          }}
        >
          <V2Tabs.Tab label="Text" />
          <V2Tabs.Tab label="Draw" />
        </V2Tabs>

        <div style={{ display: activeTab === 0 ? 'block' : 'none' }}>
          <TextSignatureTab activeTab={activeTab} />
        </div>

        {/*
          DrawSignatureTab mounts only after user first visits Draw tab (hasVisitedDraw).
          This ensures CanvasDraw initializes while visible (not inside display:none).
          After first mount it stays mounted — hidden only by CSS, never destroyed.

          IMPORTANT: We use visibility/height/overflow instead of display:none here.
          CanvasDraw has an internal ResizeObserver that sets the canvas to 0×0 when
          display:none is applied. visibility:hidden keeps the element in layout so
          ResizeObserver always sees the correct canvas dimensions.
        */}
        {hasVisitedDraw && (
          <div
            aria-hidden={activeTab !== 1 || undefined}
            style={
              activeTab !== 1
                ? {
                    visibility: 'hidden',
                    height: 0,
                    overflow: 'hidden',
                    pointerEvents: 'none',
                  }
                : {}
            }
          >
            <DrawSignatureTab activeTab={activeTab} />
          </div>
        )}
      </V2FormProvider>
    </V2Card>
  );
};
